import { getJson, deleteJson, withDone, } from '@rad/utility/http';
export const getRoster = (p) => getJson('/api/community/members', p);
export const getRosterCounts = getJson('/api/community/members/counts');
export const removeMember = (userId) => withDone(deleteJson(`/api/community/members/${userId}`))();
